import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppCoreService } from 'src/app/services/app-core.service';
import { AWBService } from 'src/app/services/operations/awb.service';
import { Observable, OperatorFunction, debounceTime, distinctUntilChanged, map } from "rxjs";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-awb-inscan',
    templateUrl: './awb-inscan.component.html',
    styleUrls: ['./awb-inscan.component.scss']
})

export class AwbInscanComponent implements OnInit {
    @Input() selectedInscan: any;
    awbInscanForm: FormGroup;
    isFormSubmitted = false;
    statusList = [{ id: 'SHIPMENT_RECEIVED', name: 'Shipment Received' }, { id: 'SHIPMENT_HOLD', name: 'On Hold' }];
    reasonList: any[] = [];

    constructor(
        private appCoreService: AppCoreService,
        public activeModal: NgbActiveModal,
        private ngxLoaderService: NgxUiLoaderService,
        private _fb: FormBuilder,
        private awbService: AWBService,
        private titleService: Title
    ) { 
        titleService.setTitle('Air Way Bill');
    }

    ngOnInit() {
        this.awbInscanForm = this._fb.group({
            ddlStatus: [null, Validators.compose([Validators.required])],
            txtRemark: []
        });
        this.bindInscanReason();
    }

    bindInscanReason() {
        this.awbService.getAllHistory('').subscribe((res: any) => {
            if (res && res.success) {
                const uniqueReasons = Array.from(new Set(res.data.map((item: any) => item.reason)))
                    .filter(reason => reason !== null)
                    .map(reason => ({ 'reason': reason }));

                this.reasonList = uniqueReasons;
            }
        })
    }

    onSaveClick() {
        this.isFormSubmitted = true;
        if (this.awbInscanForm.valid) {
            const reqObj = {
                awbId: this.selectedInscan?.id,
                status: this.awbInscanForm.get('ddlStatus')?.value,
                remark: typeof this.awbInscanForm.get('txtRemark')?.value == 'object' ? this.awbInscanForm.get('txtRemark')?.value?.reason : this.awbInscanForm.get('txtRemark')?.value,
            }
            this.ngxLoaderService.start();
            this.awbService.AwbInscan(reqObj).subscribe((res) => {
                if (res && res.success) {
                    this.ngxLoaderService.stop();
                    this.activeModal.close('');
                    this.appCoreService.showMessage('Status Updated successfully', 'Success', 'success');
                }
                if (res && !res.success) {
                    this.ngxLoaderService.stop();
                    this.appCoreService.showMessage(res.message, 'Warning', 'warning');
                }
            });
            this.ngxLoaderService.stop();
        }
    }

    reasonFormatter = (x: { reason: string }) => x.reason;

    searchReason: OperatorFunction<string, readonly { area; flag }[]> = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map((term) =>
                term === ''
                    ? []
                    : this.reasonList.filter((v) => v.reason.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
            ),
        );
}
